import styles from './../Assets/CSS/Button.module.css'; 
 
export const BlueButton = ({ title, leftIcon, rightIcon, onClick, loading, disabled }) => {
    return (
        <button className={`${styles.btn} ${styles.blueBtn}`} style={{ backgroundColor: disabled ? "#9dccfc" : "rgb(18,95,220)" }} onClick={onClick} disabled={disabled && disabled}>
            {leftIcon && leftIcon}
            {loading && loading === true ? "Please Wait..." : title}
            {rightIcon && rightIcon}
        </button>
    ) 
}

export const GreenButton = ({ title, leftIcon, rightIcon, onClick }) => {
    return (
        <button className={`${styles.btn} ${styles.greenBtn}`} onClick={onClick}>
            {leftIcon && leftIcon}
            {title}
            {rightIcon && rightIcon}
        </button>
    )
}

export const YellowButton = ({ title, leftIcon, rightIcon, onClick }) => {
    return (
        <button className={`${styles.btn} ${styles.yellowBtn}`} onClick={onClick}>
            {leftIcon && leftIcon}
            {title}
            {rightIcon && rightIcon}
        </button>
    )
}

export const SmButton = ({ title, leftIcon, rightIcon, onClick }) => {
    return (
        <button className={`${styles.smbtn} ${styles.blueBtn}`} onClick={onClick}>
            {leftIcon && leftIcon}
            {title}
            {rightIcon && rightIcon}
        </button>
    )
}

export const WideButton = ({ title, leftIcon, rightIcon, onClick, loading, disabled }) => {
    return (
        <button className={`${styles.wideBtn} ${styles.blueBtn}`} style={{ backgroundColor: disabled ? "#9dccfc" : "rgb(18,95,220)" }} onClick={onClick} disabled={disabled && disabled}>
            {leftIcon && leftIcon}
            {loading && loading === true ? "Please Wait..." : title}
            {rightIcon && rightIcon}
        </button>
    )
} 